module.exports = __webpack_public_path__ + "2590fbda63f1510d731783a5dc9115c4.png";